import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import {withRouter} from 'react-router';

import Helmet from 'react-helmet';
import {channelImageUrl} from '../../containers/channelUtils/ChannelImage';

const SITE_TITLE = 'Boosthive';

function Meta({title, fallbackTitle, description, keywords, type = 'article', image, location, canonical, meta, alternateSlug}) {
  return (
    <Helmet titleTemplate={title ? '%s' : undefined}>
      {(!title && !!fallbackTitle) && <title>{fallbackTitle}</title>}
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description}/>}
      {keywords && <meta name="keywords" content={keywords}/>}

      {canonical ? (
        <link rel="canonical" href={process.env.PUBLIC_URL + canonical} />
      ) : (
        <link rel="canonical" href={process.env.PUBLIC_URL + location.pathname} />
      )}

      {alternateSlug && [
        <link rel="alternate" hreflang="x-default" href={process.env.PUBLIC_URL + (alternateSlug === '/' ? '' : '/' + alternateSlug)} />,
        <link rel="alternate" hreflang="en" href={process.env.PUBLIC_URL + (alternateSlug === '/' ? '' : '/' + alternateSlug)} />
      ]}

      {meta && (
        meta.map(({name, content}) => {
          return (
            <meta name={name} content={content} />
          )
        })
      )}

      <meta property="og:type" content={type}/>
      <meta property="og:site_name" content={SITE_TITLE}/>
      <meta property="og:title" content={title || fallbackTitle && `${fallbackTitle} - ${SITE_TITLE}` || SITE_TITLE}/>
      <meta property="og:image" content={channelImageUrl(image)}/>
      <meta property="og:description" content={description || SITE_TITLE}/>
      <meta property="og:url" content={process.env.PUBLIC_URL + location.pathname}/>

      <meta name="twitter:card" content="summary"/>
      <meta name="twitter:site" content={SITE_TITLE}/>
      <meta name="twitter:creator" content="@Boosthive"/>
      <meta name="twitter:title" content={title || fallbackTitle && `${fallbackTitle} - ${SITE_TITLE}` || SITE_TITLE}/>
      <meta name="twitter:description" content={description || SITE_TITLE}/>
      <meta name="twitter:image" content={channelImageUrl(image)}/>
    </Helmet>
  );
}

Meta.propTypes = {
  title: PropTypes.string,
  fallbackTitle: PropTypes.string,
  description: PropTypes.string,
  keywords: PropTypes.string,
  type: PropTypes.string,
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.bool])
};

export default withRouter(Meta);



// WEBPACK FOOTER //
// ./components/meta/Meta.js